<template>
  <div class="commentReplySet" @click="hidden()">
    <div
      class="body layout-row"
      :class="{
        count3: is_item_margin(),
      }"
      @click.stop=""
      v-if="show"
    >
      <div class="layout-col item" @click="set(0)">
        <img src="../../image/dialog_relpy_icon.png" alt="" />
        <div>回复</div>
      </div>
      <div v-if="is_note()" class="layout-col item" @click="set(2)">
        <img src="../../image/dialog_reply_note.png" alt="" />
        <div>抄笔记</div>
      </div>
      <div class="layout-col item" @click="set(1)">
        <img src="../../image/dialog_reply_copy.png" alt="" />
        <div>复制</div>
      </div>
      <div class="layout-col item" @click="set(3)">
        <img src="../../image/dialog_reply_report.png" alt="" />
        <div>举报</div>
      </div>
      <div
        v-if="data.data.user_id == user_id"
        class="layout-col item"
        @click="set(4)"
      >
        <img src="../../image/ico_dialog_del.png" alt="" />
        <div>删除</div>
      </div>
      <div
        v-if="data.data.user_id == user_id"
        class="layout-col item"
        @click="set(5)"
      >
        <img src="../../image/dialog_edit_icon.png" alt="" />
        <div>编辑</div>
      </div>
    </div>

    <EditNote v-if="note.show" :data="note" />
    <inputTopic v-if="input.show" :data="input" @ok="ok" />
    <commentReport v-if="report.show" :data="report" />
  </div>
</template>

<script>
import EditNote from "./EditNote";
import commentReport from "./Report";
export default {
  components: {
    EditNote,
    commentReport,
  },
  data() {
    return {
      input: {
        show: false,
      },
      report: {
        show: false,
      },
      note: {
        show: false,
      },
      show: true,
      user_id: getUser_id(),
    };
  },
  watch: {
    "input.show"(e1, e2) {
      if (!e1) {
        this.hidden();
      }
    },
    "report.show"(e1, e2) {
      if (!e1) {
        this.hidden();
      }
    },
    "note.show"(e1, e2) {
      if (!e1) {
        this.hidden();
      }
    },
  },
  created() {
    console.log(this.$store.state.commentSet);
  },
  methods: {
    is_item_margin() {
      return this.data.data.user_id != this.user_id && !this.is_note();
    },
    is_note() {
      if (this.$route.query.is_lecture == 1) {
        return false;
      }
      if (this.$route.query.is_tidan == 1) {
        return false;
      }
      if (this.$route.query.is_message == 1) {
        return false;
      }
      return true;
    },
    hidden() {
      this.$store.commit("setCommentSetShow", {
        show: false,
        update: 0,
        data: {},
      });
    },
    copy(message) {
      var input = document.createElement("input");
      input.value = message;
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, input.value.length);
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$toast.center("复制成功");
      this.hidden();
    },
    set(type) {
      let item = this.data.data;
      this.show = false;
      if (type == 0) {
        this.input.type = 0;
        this.input.show = true;
        this.input.value = "";
        this.input.placeholder =
          `回复@${this.data.data.nickname}` +
          "你说的或许就是别人想知道的~ 评论不能少于3个字；无意义评论将会被删除";
        this.input.set_type = 0;
      }
      if (type == 1) {
        this.copy(item.content);
      }
      if (type == 2) {
        this.input.type = 1;
        this.input.add = 2;
        this.input.show = true;
        this.input.is_comment = 1;
        this.input.item = item;
        // this.input.set_type = 2;
        // this.input.comment = item.content;
      }
      if (type == 3) {
        this.report.show = true;
        this.report.item = item;
      }
      if (type == 4) {
        this.hidden();

        vant.Dialog.confirm({
          title: "",
          message: `确定删除此条评论吗？`,
          confirmButtonText: "删除",
          getContainer: "#CB_B_398",
        })
          .then(() => {
            let url = "/comment/del_comment";
            if (this.$route.query.source == 2) {
              url = "/sheet/del_comment";
            }
            if (this.$route.query.is_tidan == 1) {
              url = "/sheet/del_cate_comment";
            }
            if (this.$route.query.is_lecture == 1) {
              url = "/tiku/lecture/del_comment";
            }
            this.$axios
              .post(url, {
                sheet_id: this.$route.query.sheet_id,
                sheet_type: this.$route.query.sheet_type,
                lecture_id: this.$route.query.lecture_id,
                tab_key: item.tab_key,
                comment_id: item.comment_id,
                // exam_id:0
              })
              .then((res) => {
                if (res.code == 200) {
                  this.updata();
                }
              });
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
      }
      if (type == 5) {
        this.input.type = 0;
        this.input.show = true;
        this.input.value = item.content;
        this.input.set_type = 5;
      }
    },
    ok(data) {
      let item = this.data.data;
      if (data.set_type == 0) {
        let url = "/comment/add_comment";
        if (this.$route.query.source == 2) {
          url = "/sheet/add_comment";
        }
        if (this.$route.query.is_tidan == 1) {
          url = "/sheet/add_cate_comment";
        }
        if (this.$route.query.is_lecture == 1) {
          url = "/tiku/lecture/add_comment";
        }
        this.$axios
          .post(url, {
            sheet_id: this.$route.query.sheet_id,
            sheet_type: this.$route.query.sheet_type,
            lecture_id: this.$route.query.lecture_id,
            question_id: item.question_id,
            tab_key: item.tab_key,
            content: data.value,
            img_url: data.commentImg,
            comment_id: item.comment_id,
            to_user_id: item.user_id,
            // exam_id:0
          })
          .then((res) => {
            if (res.code == 200) {
              this.updata();
            }
          });
      }
      if (data.set_type == 5) {
        let url = "/comment/update_comment";
        if (this.$route.query.source == 2) {
          url = "/sheet/update_comment";
        }
        if (this.$route.query.is_tidan == 1) {
          url = "/sheet/update_cate_comment";
        }
        if (this.$route.query.is_lecture == 1) {
          url = "/tiku/lecture/update_comment";
        }
        this.$axios
          .post(url, {
            sheet_id: this.$route.query.sheet_id,
            sheet_type: this.$route.query.sheet_type,
            lecture_id: this.$route.query.lecture_id,
            tab_key: item.tab_key,
            content: data.value,
            img_url: data.commentImg,
            comment_id: item.comment_id,
            user_id: item.user_id,
            // exam_id:0
          })
          .then((res) => {
            if (res.code == 200) {
              this.updata();
            }
          });
      }
    },
    updata() {
      this.$store.commit("setCommentSetShow", {
        show: false,
        update: 1,
        data: {},
      });
    },
  },
  computed: {
    data() {
      return this.$store.getters.getCommentSetShow;
    },
  },
};
</script>

<style lang="scss" scoped>
.commentReplySet {
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba($color: #000000, $alpha: 0.4);
  display: flex;

  .body {
    padding: 1.3rem 0.75rem 0 0.75rem;
    box-sizing: border-box;
    margin: auto;
    width: 16.25rem;
    // height: 6rem;
    background: #ffffff;
    border-radius: 0.35rem;
    // justify-content: center;
    flex-wrap: wrap;
    .item {
      margin: auto 0.75rem 1.3rem 0.75rem;
      align-items: center;
      img {
        width: 2.1rem;
        height: 2.1rem;
        margin-bottom: 0.75rem;
      }
      div {
        font-size: 0.65rem;
        color: #6666;
      }
    }
  }
  .count3 {
    .item {
      margin: auto auto 1.3rem auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/comment/ReplySet.vue